import { withStyles } from "@material-ui/core/styles";
import ToggleView from "./ToggleView";
import styles from "./styles";

export default withStyles(styles)(ToggleView);
